import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-transfer-amount',
  templateUrl: './transfer-amount.component.html',
  styleUrls: ['./transfer-amount.component.scss'],
  standalone: false
})
export class TransferAmountComponent {
  @Input() cost!: number;
}
